import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useEventIdFromPath = () => {
  const { pathname } = useLocation();

  const eventId = useMemo(() => {
    // exclude create band path as it does not have an id
    const paths = pathname.split("/");
    if (paths.length > 3 && paths[3] === "event" && paths[4] !== "create") {
      return paths[4];
    }
    return null;
  }, [pathname]);

  return eventId;
};
